






















import { Vue, Component, Prop } from "@/shared/vuepack";

@Component({})
export default class SwitchBannerTypeConfirmationModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;

  @Prop({ type: Boolean, required: true }) bannerType!: boolean;

  get isVisible () {
    return this.value;
  }
  set isVisible (val: boolean) {
    this.$emit("input", val);
  }

  get bannerTypeLabel (): string {
    return this.bannerType === true ? "Default Banners" : "Custom Banners";
  }

  onCancel () {
    this.isVisible = false;
    this.$emit("hide");
  }

  onConfirm () {
    this.$emit("confirm", this.bannerType);
  }

  onHide () {
    this.$emit("hide");
  }
}
